import { render, staticRenderFns } from "./Unimpersonate.vue?vue&type=template&id=f1a13976"
import script from "./Unimpersonate.vue?vue&type=script&lang=js"
export * from "./Unimpersonate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports